import { render } from "./DonutPic.vue?vue&type=template&id=0c8b71aa"
import script from "./DonutPic.vue?vue&type=script&lang=js"
export * from "./DonutPic.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__